import {SidenavController} from './sidenavController';


export function sidenav(): ng.IDirective {
    return {
        restrict: 'E',
        template: require('./sidenav.html'),
        controller: SidenavController,
        controllerAs: 'sidenav',
        replace: true
    };
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/navigation/sidenav/sidenav.directive.ts
 **/